export default "__VITE_ASSET__Dtir4XYF__"